import { Client, TacticApiClient } from "@gettactic/api";
import { type QueryClient } from "@tanstack/react-query";
import * as React from "react";

type ApiClient = InstanceType<typeof Client>;

export interface TacticHooksState {
  apiClient: { client: ApiClient };
  queryClient: QueryClient;
  api: TacticApiClient;
}

const TacticHooksContext = React.createContext<TacticHooksState | null>(null);

export const TacticHooksProvider = ({
  apiClient,
  queryClient,
  children
}: {
  apiClient: { client: ApiClient };
  queryClient: QueryClient;
  children: React.ReactNode;
}) => (
  <TacticHooksContext.Provider
    value={{ apiClient, queryClient, api: apiClient as TacticApiClient }}
  >
    {children}
  </TacticHooksContext.Provider>
);

export function useTacticHooks() {
  const context = React.useContext(TacticHooksContext);
  if (!context?.apiClient || !context.queryClient) {
    throw new Error("useTacticHooks must be used within a TacticHooksProvider");
  }
  const { apiClient, queryClient, api } = context;
  return {
    apiClient: apiClient.client as ApiClient,
    queryClient: queryClient as QueryClient,
    api
  };
}
